$.lui("comp",".comp_list_events",function (selector) {
    selector.on("click",".elm_range_item",function (e) {
        let elm = $(this);
        elm.closest(".elm_nav_range").find(".state--active").removeClass("state--active");
        elm.addClass("state--active");
        /*RUN AJAX*/
    });
});